"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoyaltyActivityType = exports.LoyaltyEnrolmentSource = exports.PointEvent = exports.LoyaltyNotificationMode = exports.LoyaltyNotificationType = exports.EventType = exports.RewardType = exports.EarningType = void 0;
var EarningType;
(function (EarningType) {
    EarningType["EARN_BY_AMOUNT"] = "EARN_BY_AMOUNT";
    EarningType["EARN_BY_PURCHASE_ITEM"] = "EARN_BY_PURCHASE_ITEM";
})(EarningType = exports.EarningType || (exports.EarningType = {}));
var RewardType;
(function (RewardType) {
    RewardType["DISCOUNT_ENTIRE_SALE"] = "DISCOUNT_ENTIRE_SALE";
    RewardType["PRODUCT_DISCOUNT"] = "PRODUCT_DISCOUNT";
    RewardType["FREE_ITEM"] = "FREE_ITEM";
})(RewardType = exports.RewardType || (exports.RewardType = {}));
var EventType;
(function (EventType) {
    EventType["SIGN_UP"] = "SIGN_UP";
    EventType["NONE"] = "NONE";
})(EventType = exports.EventType || (exports.EventType = {}));
var LoyaltyNotificationType;
(function (LoyaltyNotificationType) {
    LoyaltyNotificationType["ENROLL_SUCCESS"] = "ENROLL_SUCCESS";
    LoyaltyNotificationType["REDEEMED_REWARDS"] = "REDEEMED_REWARDS";
    LoyaltyNotificationType["EARN_NEW_POINT"] = "EARN_NEW_POINT";
    LoyaltyNotificationType["REFUND_POINTS"] = "REFUND_POINTS";
})(LoyaltyNotificationType = exports.LoyaltyNotificationType || (exports.LoyaltyNotificationType = {}));
var LoyaltyNotificationMode;
(function (LoyaltyNotificationMode) {
    LoyaltyNotificationMode["SMS"] = "SMS";
    LoyaltyNotificationMode["EMAIL"] = "EMAIL";
})(LoyaltyNotificationMode = exports.LoyaltyNotificationMode || (exports.LoyaltyNotificationMode = {}));
var PointEvent;
(function (PointEvent) {
    PointEvent["EARN_POINT"] = "EARN_POINT";
    PointEvent["REDEEM_POINT"] = "REDEEM_POINT";
})(PointEvent = exports.PointEvent || (exports.PointEvent = {}));
var LoyaltyEnrolmentSource;
(function (LoyaltyEnrolmentSource) {
    LoyaltyEnrolmentSource["POS"] = "POS";
    LoyaltyEnrolmentSource["ONLINE"] = "ONLINE";
    LoyaltyEnrolmentSource["CUSTOMER_DISPLAY_SCREEN"] = "CUSTOMER_DISPLAY_SCREEN";
    LoyaltyEnrolmentSource["BACK_OFFICE"] = "BACK_OFFICE";
})(LoyaltyEnrolmentSource = exports.LoyaltyEnrolmentSource || (exports.LoyaltyEnrolmentSource = {}));
var LoyaltyActivityType;
(function (LoyaltyActivityType) {
    LoyaltyActivityType["ENROLLED"] = "ENROLLED";
    LoyaltyActivityType["DELISTED"] = "DELISTED";
    LoyaltyActivityType["ADJUSTED"] = "ADJUSTED";
    LoyaltyActivityType["EARNED_POINTS"] = "EARNED_POINTS";
    LoyaltyActivityType["REFUNDED_POINTS"] = "REFUNDED_POINTS";
    LoyaltyActivityType["REDEEMED_REWARDS"] = "REDEEMED_REWARDS";
    LoyaltyActivityType["REFUNDED_REWARDS"] = "REFUNDED_REWARDS";
})(LoyaltyActivityType = exports.LoyaltyActivityType || (exports.LoyaltyActivityType = {}));
//# sourceMappingURL=loyalty.js.map